import * as React from "react"
import { Home, PencilRuler, CalendarDays, ChartColumnIncreasing, School } from "lucide-react"
import { NavMain, type NavMainItem } from "./nav-main"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "@/components/ui/sidebar"
import { NavFooter, type NavFooterItem } from "./nav-footer"
import { useCosmos } from "@/modules/cosmos/stores/use-cosmos-store"
import { UserRole } from "@/shared/entities/users"

const items: NavMainItem[] = [
  {
    title: "Dashboard",
    url: "/my-situation",
    icon: Home,
    isActive: true,
    allowedRoles: [UserRole.STUDENT],
  },
  {
    title: "Seguimiento",
    url: "/supervisor",
    icon: ChartColumnIncreasing,
    isActive: false,
    allowedRoles: [UserRole.SUPERVISOR],
  },
  {
    title: "Estudio",
    url: "/study",
    icon: PencilRuler,
    isActive: false,
    allowedRoles: [UserRole.STUDENT, UserRole.SUPERVISOR],
  },
  {
    title: "Planificador",
    url: "/planner",
    icon: School,
    isActive: false,
    allowedRoles: [UserRole.STUDENT, UserRole.SUPERVISOR],
  },
  {
    title: "Agenda",
    url: "/calendar",
    icon: CalendarDays,
    isActive: false,
    allowedRoles: [UserRole.STUDENT, UserRole.SUPERVISOR],
  },
]

const itemsFooter: NavFooterItem[] = []

export default function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { cosmos } = useCosmos()

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader className="mx-[12px] my-4">
        <div className="h-8 w-8 overflow-hidden rounded-md">
          <img alt="Logo" src={cosmos.meta.logoUrl} className="h-full w-full object-contain" />
        </div>
      </SidebarHeader>
      <SidebarContent className="mx-[12px]">
        <NavMain items={items} />
      </SidebarContent>
      <SidebarFooter className="mx-[4px]">
        <NavFooter items={itemsFooter} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
}
